import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Dot,
} from "recharts";

const data = [
  { name: "9-10", value: 38 },
  { name: "10-11", value: 1 },
  { name: "11-12", value: 27 },
  { name: "12-02", value: 3 },
  { name: "02-04", value: 18 },
  { name: "04-06", value: 30 },
  { name: "06-08", value: 22 },
];

const CustomDot = (props) => {
  const { cx, cy, value } = props;
  if (value === 27) {
    return (
      <>
        <circle
          cx={cx}
          cy={cy}
          r={5}
          fill="orange"
          stroke="#fff"
          strokeWidth={2}
        />
        <line
          x1={cx}
          y1={cy - 30}
          x2={cx}
          y2={cy}
          stroke="black"
          strokeDasharray="4"
        />
        <rect
          x={cx - 15}
          y={cy - 50}
          width={30}
          height={25}
          rx={8}
          fill="#5D3FD3"
        />
        <text x={cx} y={cy - 32} textAnchor="middle" fill="#fff" fontSize="14">
          {value}
        </text>
      </>
    );
  }
  return null;
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{ background: "#fff", padding: "8px", border: "1px solid #ccc" }}
      >
        <p>{`Time: ${payload[0].payload.name}`}</p>
        <p>{`Access: ${payload[0].value}`}</p>
      </div>
    );
  }
  return null;
};

const AccessTrendChart = ({ data }) => (
  <div
    style={{
      height: "300px",
      padding: "30px",
      background: "#fff",
      borderRadius: "15px",
      border: "1px solid #ddd",
      boxShadow: "2px 4px 5px #eee",
    }}
  >
    <h5 style={{ marginBottom: "20px" }}>Access Trend Chart</h5>
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        data={data}
        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
      >
        <defs>
          <linearGradient id="colorAccess" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="orange" stopOpacity={0.6} />
            <stop offset="95%" stopColor="orange" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip content={<CustomTooltip />} />
        <Area
          type="monotone"
          dataKey="value"
          stroke="orange"
          fillOpacity={1}
          fill="url(#colorAccess)"
          dot={<CustomDot />}
        />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);

export default AccessTrendChart;
